import { useMutation, useQuery, useQueryClient } from "@tanstack/vue-query";
import APIClient from "@/APIClient";
import { QueryKey } from "./query-keys";
import type { UpdateMyOrganizationPayload } from "@/types";
import { useToast } from "@/composable/useToast";

export const useGetMyLicenseSummary = () =>
  useQuery({
    queryKey: [QueryKey.LICENSE_SUMMARY],
    queryFn: () => APIClient.getMyLicenseSummary(),
    staleTime: 5 * 60 * 1000,
  });

export const useUpdateMyOrganization = () => {
  const { showToast } = useToast();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: UpdateMyOrganizationPayload) => {
      return await APIClient.updateMyOrganization(payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.ORGANIZATIONS] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.AUTH] });
      showToast("organization.update-mine.success");
    },
    onError: () => {
      showToast("organization.update-mine.error", "error");
    },
  });
};
